<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="p-1">
            <form class="" @submit.prevent="submitForm">
              <div class="row">
                <div class="form-group col-12 col-md-3">
                  <label for="phone24">Nombre:</label>
                  <b-form-input v-model="level.name" autocomplete="off"/>
                  <span v-if="validation_level_1.name" class="text-danger">
                                      {{ validation_level_1.name }}
                                    </span>
                </div>
              </div>
              <div class="row">
                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {VHE_AUXILIAR_LEVEL1_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
  getterType: 'level1Vhe/getField',
  mutationType: 'level1Vhe/updateField',
})

export default {
  name: "FormView",
  components: {
    BCol,
    BRow,
    BCard,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      edit: false,
      showLoading: false,
    }
  },
  computed: {
    ...mapState('auxiliariesLevel1Vhe', ['validation_level_1']),
    ...mapFields({
      level: 'level',
    }),
  },
  created() {
    this.$store.commit('auxiliariesLevel1Vhe/RESET_STATE')
    this.$store.commit('auxiliariesLevel1Vhe/CLEAR_VALIDATION')
    if (this.$route.params.id) {
      this.edit = true
      this.getLevel1()
    } else {
      this.edit = false
    }
    this.$root.$refs.auxiliariesLevel1Form = this
  },
  methods: {
    getLevel1() {
      this.showLoading = true
      this.$store.dispatch('level1Vhe/findLevels1', {
        id: this.$route.params.id ?? this.level.id
      })
          .then(response => {
            this.showLoading = false
          })
          .catch(error => {
            this.showLoading = false
          })
    },
    cancel() {
      this.$router.push(VHE_AUXILIAR_LEVEL1_LIST)
    },
    createAuxiliar() {
      this.$store.dispatch('level1Vhe/createLevels1', this.level)
          .then(response => {
            helper.showToast('Nivel creado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(VHE_AUXILIAR_LEVEL1_LIST)
          })
          .catch(error => {
            helper.showToast('Error al crear nivel', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    updateAuxiliar() {
      this.$store.dispatch('level1Vhe/updateLevels1', this.level)
          .then(response => {
            helper.showToast('Nivel editado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(VHE_AUXILIAR_LEVEL1_LIST)
          })
          .catch(error => {
            helper.showToast('Error al editar nivel', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    submitForm() {
      if (this.$route.params.id) {
        this.updateAuxiliar()
      } else {
        this.createAuxiliar()
      }
    },
  },
}
</script>